import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AgreementsState } from "./agreements.state";
import { getAgreements } from "./agreements.thunk";
import { AgreementsResponse } from "./agreements.types";

const initialState: AgreementsState = {
  data: [],
  error: null,
  status: "idle",
};

const agreementsSlice = createSlice({
  name: "agreements",
  initialState,
  reducers: {
    clearAgreements: (state) => {
      state.data = [];
      state.error = null;
      state.status = "idle";
    },
  },
  extraReducers: (build) => {
    build
      .addCase(getAgreements.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(
        getAgreements.fulfilled,
        (state, action: PayloadAction<AgreementsResponse>) => {
          state.status = "success";
          state.data = action.payload.data.map((item) => ({
            ...item.agreement,
            text: item.text,
            isRequired: true,
          }));
        },
      )
      .addCase(
        getAgreements.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.status = "error";
          state.error = action.payload ?? "Bir hata oluştu.";
        },
      );
  },
});

export const { clearAgreements } = agreementsSlice.actions;
export default agreementsSlice.reducer;
